@let row = view;
<div class="ut-dash-row__status">
  <span class="ut-dash-icon ut-dash-row__icon ut-dash-row__icon--{{ row.tone }}" aria-hidden="true">
    <i class="material-icons">{{ row.icon }}</i>
  </span>
  @if (row.status) {
    <span class="ut-dash-row__status-text">{{ row.status }}</span>
  }
</div>

<div class="ut-dash-row__details">
  @if (row.recruited) {
    <span class="ut-dash-row__recruited">
      <i class="material-icons ut-dash-row__stat-icon" aria-hidden="true">label_outline</i>
      You've Been Recruited!
    </span>
  }
  @if (row.survey) {
    <span class="ut-dash-row__emphasis">Requirement Survey Requested</span>
  }
  <a class="ut-dash-row__name" [href]="row.href">{{ row.name }}</a>
  @if (row.testers !== undefined || row.bugs !== undefined) {
    <div class="ut-dash-row__stats">
      @if (row.testers !== undefined) {
        <span class="ut-dash-row__stat">
          <i class="material-icons ut-dash-row__stat-icon" aria-hidden="true">people</i>
          {{ row.testers }} {{ row.testers === 1 ? 'tester' : 'testers' }}
        </span>
      }
      @if (row.bugs !== undefined) {
        <span class="ut-dash-row__stat">
          <i class="material-icons ut-dash-row__stat-icon" aria-hidden="true">bug_report</i>
          {{ row.bugs }} {{ row.bugs === 1 ? 'bug' : 'bugs' }}
        </span>
      }
    </div>
  }
</div>

<div class="ut-dash-row__timing">
  @if (row.start) {
    <div class="ut-dash-row__date"><span class="ut-dash-row__emphasis">Start: </span>{{ row.start | date: 'shortDate' }} - {{ row.start | date: 'shortTime' }}</div>
  }
  @if (row.end) {
    <div class="ut-dash-row__date"><span class="ut-dash-row__emphasis">End: </span>{{ row.end | date: 'shortDate' }} - {{ row.end | date: 'shortTime' }}</div>
  }
  @if (row.showLock) {
    <span class="ut-dash-row__lock">
      <i class="material-icons ut-dash-row__stat-icon" aria-hidden="true">timer</i>
      <span class="ut-dash-row__emphasis">Locks: {{ row.end ? (row.end | utTimeLeft: row.hidePriorLock) : 'TBD' }}</span>
    </span>
  }
</div>
